module.exports = __webpack_public_path__ + "media/images/icon-search-primary-803b2c6e2f1136a53d9c890948ac0522.svg";